module.exports = __webpack_public_path__ + "img/organization-members.eec1f17e.png";